<template>
	<header class="modal-header">
		<font-awesome-icon
			v-if="showBackCaret && !removeBackCaret"
			role="button"
			@click="$emit('back')"
			:icon="['far', 'chevron-left']"
			class="back"
			aria-label="back"
		/>
		<span v-else></span>
		<span
			class="modal-title b360-handle-overflow"
			role="heading"
			data-test="modal-title"
			:title="
				truncateModalFields({
					fieldName: getHeading,
					fieldLength: 36,
					attributeName: 'title',
				})
			"
		>
			{{
				truncateModalFields({
					fieldName: getHeading,
					fieldLength: 36,
				})
			}}
		</span>
		<font-awesome-icon
			:icon="['fal', 'times']"
			@click="$emit('close')"
			role="button"
			aria-label="close"
			class="close"
		/>
	</header>
</template>

<script>
import { VIEWS } from './constants';
import { truncateModalFields } from '@/views/client-connect-v2/helpers';

export default {
	name: 'OverviewModalHeader',
	props: {
		currentView: String,
		contactName: String,
		currentAlertPreference: Object,
		removeBackCaret: Boolean,
	},
	data() {
		return {
			VIEWS,
			noBackCaretViews: [
				VIEWS.ADD_CONTACT,
				VIEWS.DUPLICATE_CONTACT,
				VIEWS.DUPLICATE_LOAN,
				VIEWS.HOME,
				VIEWS.INACTIVE_CONTACT,
				VIEWS.UPDATE_CONTACT_TYPE,
				VIEWS.CONFIRM_FILTER_SELECTION,
				VIEWS.DEACTIVATE_CONTACT,
				VIEWS.REACTIVATE_CONTACT,
			],
		};
	},
	computed: {
		getHeading() {
			let heading;
			switch (true) {
				case this.currentView === VIEWS.ACTIVITY:
					heading = `Activity for ${this.contactName}`;
					break;
				case this.currentView === VIEWS.ALERT_LIST:
					heading = `Alerts for ${this.contactName}`;
					break;
				case this.currentView === VIEWS.ALERT_SETTINGS:
					heading = this.currentAlertPreference
						? this.currentAlertPreference.alertPreference &&
						  this.currentAlertPreference.alertPreference.type.desc
						: '';
					break;
				case this.currentView === VIEWS.CONTACT_SETTINGS:
					heading = `Settings for ${this.contactName}`;
					break;
				case this.currentView === VIEWS.DUPLICATE_CONTACT:
				case this.currentView === VIEWS.INACTIVE_CONTACT:
					heading = 'Duplicate Contact';
					break;
				case this.currentView === VIEWS.LOANS_LIST:
					heading = `Loans for ${this.contactName}`;
					break;
				default:
					heading = this.currentView;
			}
			return heading;
		},
		showBackCaret() {
			return !this.noBackCaretViews.includes(this.currentView);
		},
	},
	methods: {
		truncateModalFields,
	},
};
</script>

<style lang="scss" scoped>
.modal-header {
	background: $white;
	color: $black;
	line-height: normal;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid $border-color-light;
	@include rem('padding', 18px 20px);
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;

	.close {
		@include rem('font-size', 22px);
		cursor: pointer;
		line-height: normal;
	}

	.back {
		@include rem('font-size', 20px);
		cursor: pointer;
		@include rem('margin-right', 20px);
		line-height: normal;
	}

	.modal-title {
		font-weight: 500;
		line-height: normal;
		@include rem('font-size', 18px);
	}
}
</style>
